import { useMutation } from '@apollo/client'

import { UpdateOrderShippingDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

export const useUpdateTrackingNumber = () => {
  const [mutate, { loading, error }] = useMutation(
    UpdateOrderShippingDocument,
    {
      client: atlasClient,
      refetchQueries: ['OrderBillingShipping'],
    },
  )

  return {
    updateTrackingNumber: (orderId: string, trackingNumber: string) => {
      return mutate({
        variables: {
          input: {
            orderId: orderId,
            shippingInfo: {
              trackingNumber,
            },
          },
        },
      })
    },
    loading,
    error,
  }
}
